import { US } from "constants/countryCodes";
import { Entity } from "types/Models/entity";

export const entitiesSortedByCountry = (entities: Entity[]) => {
  const usEntities = entities?.filter((e) => e.country_code === US);
  const otherCountryEntities = entities?.filter((e) => e.country_code !== US);
  const sortedEntities = [
    ...(usEntities ?? []),
    ...(otherCountryEntities ?? []),
  ];
  return { sortedEntities, usEntities, otherCountryEntities };
};
